import { RequirementMilestoneAssignmentParams } from '@/backend/access/requirementMilestoneAssignment/types';

export class RequirementMilestoneAssignment {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  requirementId: string;
  milestoneId: string;

  constructor(params: RequirementMilestoneAssignmentParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.requirementId = params.requirementId;
    this.milestoneId = params.milestoneId;
  }
}
